import SessionCalendar from './session-calendar'

export default SessionCalendar
